import React from 'react';
import PropTypes from 'prop-types';
import {Button} from 'react-bootstrap';
import {withRouter} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {FaArrowLeft, FaBuilding} from 'react-icons/fa';
import {CLUB_RETURN_PATH_KEY, getActiveClubPath, getClubPath} from '../util/club-mode';
import {getContextualBackPath} from '../util/contextual-navigation';

export const ClubReturnButton = ({history, location, role}) => {
  const {t} = useTranslation();
  const returnPath = getClubPath(CLUB_RETURN_PATH_KEY);
  const currentPath = (location.pathname || '').toLowerCase();
  const backPath = getContextualBackPath(currentPath, role);
  const showClubReturn = Boolean(
    !getActiveClubPath()
    && returnPath
    && !currentPath.startsWith('/club/')
    && !currentPath.startsWith('/login')
  );

  if (!backPath && !showClubReturn) {
    return null;
  }

  return (
    <nav className="navbar-context-navigation" aria-label={t('NAV_CONTEXTUAL_NAVIGATION')}>
      {backPath ? (
        <Button type="button" variant="outline-light" className="navbar-context-navigation__button" title={t('NAV_BACK_PREVIOUS')} aria-label={t('NAV_BACK_PREVIOUS')} onClick={() => history.push(backPath)}>
          <FaArrowLeft aria-hidden="true"/>
          <span>{t('NAV_BACK_PREVIOUS')}</span>
        </Button>
      ) : null}
      {showClubReturn ? (
        <Button type="button" variant="outline-light" className="navbar-context-navigation__button navbar-context-navigation__button--club" title={t('NAV_RETURN_TO_CLUB')} aria-label={t('NAV_RETURN_TO_CLUB')} onClick={() => {
          window.sessionStorage.removeItem(CLUB_RETURN_PATH_KEY);
          history.push(returnPath);
        }}>
          <FaBuilding aria-hidden="true"/>
          <span>{t('NAV_RETURN_TO_CLUB')}</span>
        </Button>
      ) : null}
    </nav>
  );
};

ClubReturnButton.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  role: PropTypes.number
};

ClubReturnButton.defaultProps = {role: null};

export default withRouter(ClubReturnButton);
